<template>
  <nav class="navbar navbar-light bg-white border-bottom px-4">
    <div class="d-flex w-100 justify-content-between align-items-center">
      <div class="d-flex align-items-center gap-3">
        <button class="btn btn-light" @click="$emit('toggleSidebar')">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="currentColor"
            class="bi bi-list"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg>
        </button>
        <div v-if="subtitle">
          <h2 class="mb-0 fw-bold">{{ title }}</h2>
          <p class="text-muted mb-0 small">{{ subtitle }}</p>
        </div>
        <h2 v-else class="mb-0 fw-bold">{{ title }}</h2>
      </div>
      <button class="btn btn-outline-danger btn-sm" @click="$emit('logout')">
        {{ $t('common.logout') }}
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'EmployeeNavbar',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.navbar {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
</style>
